import { AbstractSuperEventListener, getSuperEventListenerSymbols } from '../../types/lux'

function __$executeSuperEventListeners(target, eventName, ...args) {
  const { _superEventListeners } = getSuperEventListenerSymbols(target)
  const superListeners = _superEventListeners[eventName]
  if (superListeners) {
    for (const listener of superListeners) {
      listener.call(target, ...args)
    }
  }
}
function __$executeEventListeners(target, eventName, ...args) {
  const { _eventListeners } = getSuperEventListenerSymbols(target)
  const listeners = _eventListeners[eventName]
  if (listeners) {
    for (const listener of listeners) {
      listener.call(target, ...args)
    }
  }
}

export default AbstractSuperEventListener

/** @constructor @extends {AbstractSuperEventListener} @suppress {checkTypes} */ function _SuperEventListener() {}
AbstractSuperEventListener.__implement(
  _SuperEventListener.prototype = /** @type {!AbstractSuperEventListener} */ ({
    addSuperEventListener(eventName, cb) {
      const { _superEventListeners } = getSuperEventListenerSymbols(this)
      let superListeners = _superEventListeners[eventName]
      if (!superListeners) {
        superListeners = []
        _superEventListeners[eventName] = superListeners
      }
      superListeners.push(cb)
    },
    addEventListener(eventName, cb) {
      const { _eventListeners } = getSuperEventListenerSymbols(this)
      let listeners = _eventListeners[eventName]
      if (!listeners) {
        listeners = []
        _eventListeners[eventName] = listeners
        EventTarget.prototype.addEventListener.call(this, eventName, (ev, ...args) => {
          let cancelled = false
          /** @type {guest.maurice.ISuperEvent} */
          const superEvent = ev
          superEvent.cancel = () => {
            cancelled = true
          }
          __$executeSuperEventListeners(this, eventName, superEvent, ...args)
          if (!cancelled) {
            __$executeEventListeners(this, eventName, ev, ...args)
          }
        })
      }
      listeners.push(cb)
    },
    removeEventListener(eventName, cb) {
      const { _eventListeners } = getSuperEventListenerSymbols(this)
      const el = _eventListeners[eventName]
      if (!el) return
      el.splice(el.indexOf(cb), 1)
    },
  }),
)